import { Grid } from '@mui/material';
import React from 'react';

function SettingsV2() {
	return (
		<Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				sx={{ background }}
			></Grid>
		</Grid>
	);
}

export default SettingsV2;
